import { useMemo, useState } from "react";
import { useDateLimits } from "@/api/date-limits";
import { DEFAULT_RANGE_ID, type DistributionRange, latestSelectableDate, presetRange, type Selection } from "./ranges";

export const useHomeRange = () => {
  const [today] = useState(() => new Date());
  const [selection, setSelection] = useState<Selection>({ id: DEFAULT_RANGE_ID });
  const { data: dateLimits, isFetched } = useDateLimits();

  // Derived rather than held in state: the latest data date arrives after first paint,
  // and a preset range has to move with it instead of staying pinned to the mount.
  const range = useMemo<DistributionRange>(
    () => (selection.id === "custom" ? selection : presetRange(selection.id, today, dateLimits?.maxDate ?? undefined)),
    [selection, today, dateLimits?.maxDate],
  );

  const maxSelectableDate = useMemo(
    () => latestSelectableDate(today, dateLimits?.maxDate ?? undefined),
    [today, dateLimits?.maxDate],
  );

  return { range, maxSelectableDate, setSelection, ready: isFetched };
};
